"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoService = void 0;
const urlParser_1 = require("./providers/urlParser");
const urlParser = (0, urlParser_1.default)();
const VideoService = {
    parseProvider: (url) => {
        return urlParser.parseProvider(url);
    },
    parseUrl: (url) => {
        const result = urlParser.parse(url);
        return result ? result : undefined;
    },
    createEmbedUrl: (videoObject, cookieCategoriesAcceptance) => {
        var _a, _b;
        const provider = videoObject.provider;
        const plugin = urlParser.plugins[provider];
        return (_b = (_a = plugin === null || plugin === void 0 ? void 0 : plugin.createEmbedUrl) === null || _a === void 0 ? void 0 : _a.call(plugin, videoObject, {}, cookieCategoriesAcceptance)) !== null && _b !== void 0 ? _b : '';
    },
    checkIsValidVideo: (videoUrl) => {
        const videoObj = VideoService.parseUrl(videoUrl);
        const provider = videoObj === null || videoObj === void 0 ? void 0 : videoObj.provider;
        return !!(provider && urlParser.plugins[provider]);
    },
    checkIfEmbedUrl: (url) => {
        return url.indexOf('embed') !== -1;
    },
    getPreviewImage: (url) => {
        var _a;
        const videoObj = VideoService.parseUrl(url);
        if (!videoObj || !VideoService.checkIfVideo(videoObj))
            return undefined;
        const videoProvider = videoObj.provider;
        const hasYoutubeVideoProvider = VideoService.checkIfYoutube(videoProvider);
        if (hasYoutubeVideoProvider) {
            const youtubePlugin = urlParser.plugins['youtube'];
            return (_a = youtubePlugin === null || youtubePlugin === void 0 ? void 0 : youtubePlugin.createShortImageUrl) === null || _a === void 0 ? void 0 : _a.call(youtubePlugin, videoObj, 'default');
        }
        return undefined;
    },
    checkIfYoutube: (videoProvider) => {
        return !!videoProvider.match(/(youtube|youtu|ytimg)/gi);
    },
    checkIfVideo: (videoObject) => {
        return videoObject.mediaType === 'video';
    },
};
exports.VideoService = VideoService;
